import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

function isEnabled() {
  return (
    typeof window !== 'undefined' &&
    typeof ReactGA !== 'undefined' &&
    typeof TagManager !== 'undefined' &&
    process.env.REACT_APP_GOOGLE_ANALYTICS &&
    process.env.REACT_APP_GOOGLE_TAG_MANAGER
  );
}

function init() {
  if (isEnabled()) {
    const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS, { debug: isDev });
    TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER });
  }
}

function initializePixel(advancedMatching = null) {
  const metaOptions = {
    autoConfig: true,
    debug: false,
  };
  ReactPixel.init(process.env.REACT_APP_META_PIXEL, advancedMatching, metaOptions);
}

function sendEvent(action, label) {
  if (isEnabled()) {
    const payload = { category: 'NISO', action, label };
    ReactGA.event(payload);
  }
}

function sendPixelEvent(event, data) {
  if (isEnabled()) ReactPixel.track(event, data);
}

function sendCustomPixelEvent(event, data) {
  if (isEnabled()) ReactPixel.trackCustom(event, data);
}

function sendPageview(path) {
  if (isEnabled()) {
    ReactGA.set({ page: `${path}` });
  }
}

export default {
  init,
  sendEvent,
  sendPageview,
  sendPixelEvent,
  sendCustomPixelEvent,
  initializePixel,
};
